import { createSlice } from "@reduxjs/toolkit";

const initialProjectsStatusesState = {};

const projectsStatusesSlice = createSlice({
  name: "projectsStatuses",
  initialState: initialProjectsStatusesState,
  reducers: {
    setProjectsStatusesData: (_state, action) =>
      action.payload.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setProjectsStatusesData } = projectsStatusesSlice.actions;

export const projectsStatuses = projectsStatusesSlice.reducer;

export default projectsStatusesSlice.reducer;
